import {useDevice, useIsInViewport} from 'platform/foundation';
import styled from 'styled-components';

import {useEffect, useRef} from 'react';

import {DocumentPreviewPage} from '../types/DocumentPreviewPage';
import {UseDocumentPreviewReturnType} from '../types/UseDocumentPreviewReturnType';
import {ImagePreviewWithZoom} from './ImagePreviewWithZoom';

interface DocumentPreviewSlideshowItemProps {
  documentPage: DocumentPreviewPage;
  documentPreview: UseDocumentPreviewReturnType;
  onSlideshowItemInView: VoidFunction;
}

export function DocumentPreviewSlideshowItem(props: DocumentPreviewSlideshowItemProps) {
  const device = useDevice();

  const boxRef = useRef<HTMLDivElement>(null);

  const isInView = useIsInViewport(boxRef, THRESHOLD);

  /**
   * @description
   * Whenever an image item is inView, we trigger a callback to level up,
   * which sets the pointer to this element for comparison.
   * If the pointer is not equal to the activeIndex from controls,
   * then scrollIntoView is triggered to this element
   */
  useEffect(() => {
    if (isInView && device !== 'mobile' && device !== 'tablet') {
      props.onSlideshowItemInView();
    }
  }, [device, isInView, props]);

  return (
    <StyledSlideshowItemWrapper ref={boxRef}>
      <ImagePreviewWithZoom
        documentPage={props.documentPage}
        documentPreview={props.documentPreview}
      />
    </StyledSlideshowItemWrapper>
  );
}

const StyledSlideshowItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-block: ${({theme}) => theme.getSize(4)};
  border-radius: ${({theme}) => theme.radii.medium};
`;

const THRESHOLD = 0.85;
